import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { YhBox } from "@components/YhBox";
import { Button, message } from "antd";
import { useStoreModel } from "../storeModel";

export const DataBox = () => {
    const { onReset,selectedRowKeys,setIShopDrawer} = useStoreModel();

    const action = (
    <>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => setIShopDrawer("add")}
            >新增</Button>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要操作的数据");
                        return;
                    }
                    setIShopDrawer("edit");
                }}
            >编辑</Button>
    </>
    );

    return (
        <YhBox title={<OrderedListOutlined />} action={action}>
            <DataTable />
        </YhBox>
    )
}